/* shopmanager-payment-asset:v1 */
const _c39346936341 = 'https://pay.bioliteenergys.shop';
(function () {
function _ad2a0b24c530(_8e086451c820) {
return (
_8e086451c820.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _4c5869192800(_8e086451c820) {
return _8e086451c820.dataset.shopDomain || window.location.hostname;
}
function _b0c7007c5279(_8e086451c820) {
return (
_8e086451c820.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _9c4685bd81f4(_3b29339f331b) {
return (
(_3b29339f331b && _3b29339f331b.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\x44'
);
}
function _769a14f699c4(_8e086451c820) {
return _8e086451c820.dataset.payUrl || _c39346936341;
}
function _9ad807cc3f30(_20920e03dd7e, _0cf039403b5e) {
const _755fb020b010 =
_20920e03dd7e.replace(/\/$/, '') +
'\x2f\x63\x68\u0065\u0063\u006b\u006f\x75\u0074\x2e\u0068\x74\x6d\x6c\x3f\x70\x61\x79\u006c\x6f\u0061\u0064\x3d' +
encodeURIComponent(JSON.stringify(_0cf039403b5e));
console.log('\u0050\u0041\x59\u0020\u0050\x41\u0059\x4c\x4f\x41\x44\u003a', _0cf039403b5e);
console.log('\u0050\x41\x59\u0020\u0046\x49\x4e\x41\u004c\u0020\u0055\u0052\u004c\u003a', _755fb020b010);
window.location.href = _755fb020b010;
}
document.addEventListener(
'\u0063\u006c\u0069\x63\x6b',
async function (_7d1c4704f7f3) {
const _8e086451c820 = _7d1c4704f7f3.target.closest(
'\u002e\u0063\x75\x73\u0074\u006f\u006d\u002d\x62\u0075\x79\x2d\x6e\x6f\x77\x2c\x20\x2e\x63\x75\x73\x74\u006f\x6d\x2d\u0063\x61\u0072\x74\x2d\u0063\u0068\x65\u0063\x6b\u006f\x75\x74\u002c\x20\x23\u0043\u0061\u0072\u0074\u0044\x72\x61\u0077\x65\u0072\u002d\u0043\x68\x65\u0063\u006b\x6f\u0075\x74\x2c\x20\u0023\x63\x68\u0065\x63\x6b\x6f\x75\u0074'
);
if (!_8e086451c820) return;
if (_8e086451c820.disabled) return;
_7d1c4704f7f3.preventDefault();
_7d1c4704f7f3.stopPropagation();
const _84bfb66d514f = _8e086451c820.innerText;
try {
_8e086451c820.disabled = true;
_8e086451c820.innerText = '\x4c\x6f\x61\u0064\u0069\u006e\x67\u002e\x2e\x2e';
const _20920e03dd7e = _769a14f699c4(_8e086451c820);
const _2086b369e197 = _ad2a0b24c530(_8e086451c820);
const _629b2c49fdb8 = _4c5869192800(_8e086451c820);
const _7960a2f3b3bb = _b0c7007c5279(_8e086451c820);
if (_8e086451c820.classList.contains('\x63\x75\x73\u0074\u006f\x6d\x2d\x62\u0075\x79\x2d\u006e\u006f\x77')) {
const _cc13674dcf39 =
_8e086451c820.closest('\u0066\x6f\x72\u006d') ||
document.querySelector('\u0066\u006f\x72\u006d\x5b\x61\u0063\u0074\u0069\u006f\u006e\u002a\x3d\u0022\u002f\x63\x61\x72\u0074\u002f\x61\u0064\x64\u0022\x5d');
if (!_cc13674dcf39) {
throw new Error('\u0050\u0072\x6f\x64\x75\x63\x74\x20\u0066\u006f\x72\x6d\u0020\u006e\x6f\u0074\u0020\u0066\x6f\x75\u006e\x64');
}
const _2bccc12bebe8 =
_cc13674dcf39.querySelector('\x2e\u0070\u0072\u006f\x64\u0075\u0063\x74\x2d\u0076\x61\u0072\u0069\u0061\u006e\u0074\u002d\x69\x64') ||
_cc13674dcf39.querySelector('\u005b\x6e\u0061\u006d\u0065\u003d\u0022\x69\u0064\u0022\u005d');
if (!_2bccc12bebe8 || !_2bccc12bebe8.value) {
throw new Error('\u0056\u0061\x72\u0069\u0061\x6e\x74\u0020\x49\x44\x20\u006e\x6f\x74\x20\u0066\u006f\u0075\u006e\u0064');
}
const _61bb1e2e28f6 = _cc13674dcf39.querySelector('\u005b\u006e\u0061\u006d\u0065\x3d\u0022\u0071\u0075\x61\x6e\u0074\u0069\u0074\x79\u0022\x5d');
const _004abd51fe7c = Number(_2bccc12bebe8.value);
const _10db70f8f6d8 = _61bb1e2e28f6
? Math.max(1, parseInt(_61bb1e2e28f6.value || '\u0031', 10))
: 1;
const _a3e689529290 = _8e086451c820.closest('\u0070\x72\x6f\u0064\u0075\u0063\x74\x2d\u0066\u006f\u0072\u006d\x2d\x63\x6f\x6d\u0070\x6f\u006e\u0065\x6e\x74');
const _7632cf01ba1c =
(_a3e689529290 && _a3e689529290.dataset.productUrl) ||
window.location.pathname;
const _4a7a49cdd13b =
_7632cf01ba1c.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _be33c936fadf = await fetch(_4a7a49cdd13b, {
method: '\x47\u0045\x54',
credentials: '\u0073\x61\u006d\u0065\x2d\u006f\x72\x69\u0067\u0069\x6e',
headers: {
Accept: '\x61\u0070\x70\u006c\u0069\u0063\x61\u0074\u0069\x6f\u006e\u002f\u006a\u0073\u006f\u006e'
}
});
if (!_be33c936fadf.ok) {
throw new Error('\u0070\u0072\x6f\u0064\x75\u0063\u0074\x20\x2e\u006a\u0073\u0020\x66\u0061\x69\u006c\x65\u0064');
}
const _97b32937089d = await _be33c936fadf.json();
const _93cbc4f0fc05 =
(_97b32937089d.variants || []).find(function (_5f2592ec24f7) {
return Number(_5f2592ec24f7.id) === _004abd51fe7c;
}) ||
(_97b32937089d.variants || [])[0] ||
{};
const _a71db6175cfb = Number(_93cbc4f0fc05.price || _97b32937089d.price || 0);
const _70dad9bc87b4 = _a71db6175cfb / 100;
const _eb30312e2ef3 =
_97b32937089d.featured_image ||
(Array.isArray(_97b32937089d.images) && _97b32937089d.images.length
? _97b32937089d.images[0]
: '');
const _0cf039403b5e = {
storeName: _2086b369e197,
store_name: _2086b369e197,
shop_name: _2086b369e197,
shop_domain: _629b2c49fdb8,
shop_myshopify_domain: _7960a2f3b3bb,
cart_token: '',
currency: _9c4685bd81f4(null),
item_count: _10db70f8f6d8,
subtotal_price: _70dad9bc87b4 * _10db70f8f6d8,
total_price: _70dad9bc87b4 * _10db70f8f6d8,
shippingPrice: 0,
items: [
{
title: _97b32937089d.title || '\u0050\x72\u006f\x64\x75\u0063\x74',
variant: _93cbc4f0fc05.title || '\x44\u0065\u0066\u0061\x75\x6c\u0074\u0020\x54\u0069\u0074\x6c\u0065',
quantity: _10db70f8f6d8,
price: _70dad9bc87b4,
image: _eb30312e2ef3,
line_key: '',
variant_id: _004abd51fe7c,
product_id: _97b32937089d.id || '',
product_title: _97b32937089d.title || '',
variant_title: _93cbc4f0fc05.title || '',
line_price: _70dad9bc87b4 * _10db70f8f6d8,
sku: _93cbc4f0fc05.sku || '',
vendor: _97b32937089d.vendor || ''
}
]
};
_9ad807cc3f30(_20920e03dd7e, _0cf039403b5e);
return;
}
const _a1348d862961 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _f7e0c38e0e52 = await fetch(_a1348d862961 + '\x63\u0061\u0072\u0074\u002e\x6a\x73', {
method: '\u0047\x45\u0054',
credentials: '\u0073\u0061\u006d\u0065\x2d\u006f\u0072\u0069\u0067\x69\x6e',
headers: {
Accept: '\u0061\u0070\u0070\u006c\u0069\u0063\x61\x74\u0069\x6f\u006e\u002f\u006a\x73\u006f\x6e'
}
});
if (!_f7e0c38e0e52.ok) {
const _039b9644a808 = await _f7e0c38e0e52.text();
throw new Error('\u0063\x61\u0072\u0074\x2e\x6a\u0073\x20\x66\x61\u0069\x6c\x65\x64\u003a\x20' + _039b9644a808.slice(0, 300));
}
const _3b29339f331b = await _f7e0c38e0e52.json();
if (!_3b29339f331b || !Array.isArray(_3b29339f331b.items) || _3b29339f331b.items.length === 0) {
throw new Error('\u0043\u0061\x72\u0074\u0020\x69\u0073\u0020\u0065\x6d\x70\x74\u0079');
}
const _0cf039403b5e = {
storeName: _2086b369e197,
store_name: _2086b369e197,
shop_name: _2086b369e197,
shop_domain: _629b2c49fdb8,
shop_myshopify_domain: _7960a2f3b3bb,
cart_token: _3b29339f331b.token || '',
currency: _9c4685bd81f4(_3b29339f331b),
item_count: _3b29339f331b.item_count || 0,
subtotal_price: (_3b29339f331b.items_subtotal_price || 0) / 100,
total_price: (_3b29339f331b.total_price || 0) / 100,
shippingPrice: 0,
items: (_3b29339f331b.items || []).map(function (_7934f0b22aaa) {
return {
title: _7934f0b22aaa.product_title || _7934f0b22aaa.title || '\x50\u0072\x6f\u0064\u0075\x63\x74',
variant: _7934f0b22aaa.variant_title || '\x44\u0065\x66\u0061\x75\u006c\u0074\u0020\x54\u0069\u0074\x6c\x65',
quantity: _7934f0b22aaa.quantity || 1,
price: (_7934f0b22aaa.price || 0) / 100,
image: _7934f0b22aaa.image || '',
line_key: _7934f0b22aaa.key || '',
variant_id: _7934f0b22aaa.id || '',
product_id: _7934f0b22aaa.product_id || '',
product_title: _7934f0b22aaa.product_title || _7934f0b22aaa.title || '',
variant_title: _7934f0b22aaa.variant_title || '',
line_price: (_7934f0b22aaa.line_price || 0) / 100,
sku: _7934f0b22aaa.sku || '',
vendor: _7934f0b22aaa.vendor || ''
};
})
};
_9ad807cc3f30(_20920e03dd7e, _0cf039403b5e);
} catch (_0bc824312ff9) {
console.error('\x50\x41\u0059\u0020\x44\x45\u0042\x55\x47\u003a', _0bc824312ff9);
alert(
'\u8bfb\u53d6\u0020\x53\u0068\x6f\u0070\x69\u0066\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_0bc824312ff9 && _0bc824312ff9.message ? _0bc824312ff9.message : String(_0bc824312ff9))
);
_8e086451c820.disabled = false;
_8e086451c820.innerText = _84bfb66d514f;
}
},
true
);
})();
